import { apiClient } from './client';

interface PdfExportStatus {
  can_export: boolean;
  current_count: number;
  max_count: number | null;
  remaining: number | null;
}

interface PdfExportResult {
  success: boolean;
  message?: string;
  error?: string;
}

export const pdfExportApi = {
  // Check current PDF export status
  async getExportStatus(): Promise<PdfExportStatus> {
    const response = await apiClient.get('/api/pdf-export-status');
    return (response as any).data as PdfExportStatus;
  },

  // Record a PDF export (call this when user actually exports)
  async recordExport(): Promise<PdfExportResult> {
    const response = await apiClient.post('/api/pdf-export');
    return (response as any).data as PdfExportResult;
  }
};